import React from 'react';
import PracticeSettingsService from '../services/PracticeSettingsService';
import { PRACTICE_PLAYER_MODES, normalizePracticePlayerMode } from '../services/PracticePlayerService';
import { unlockPracticeAudio } from '../services/soundEffects';
import { unlockListeningAudio } from '../services/ListeningAudioTransport';
import { t } from '../i18n';
import testAndRepeatImage from '../assets/practice/modes/TestAndRepeatPractice.png';
import listeningPracticeImage from '../assets/practice/modes/ListeningPractice.png';
import './PracticeSettings.css';

function PracticeSettings({
  isOpen,
  onClose,
  onStart,
  onStartPlayer,
  description,
  errorMessage,
  playerMode = PRACTICE_PLAYER_MODES.FOCUS,
}) {
  const resolvedPlayerMode = normalizePracticePlayerMode(playerMode);

  const buildSettings = () => {
    const maxExcludeGrade = PracticeSettingsService.normalizeMaxExcludeGrade(
      PracticeSettingsService.DEFAULT_SETTINGS.maxExcludeGrade
    );
    return {
      practiceCardTypeFilter: PracticeSettingsService.PRACTICE_CARD_TYPE_FILTERS.ALL,
      maxExcludeGrade,
      excludedGrades: PracticeSettingsService.getExcludedGradesFromMax(maxExcludeGrade),
      maxScore: PracticeSettingsService.normalizeMaxScore(
        PracticeSettingsService.DEFAULT_SETTINGS.maxScore
      ),
      playerMode: resolvedPlayerMode,
    };
  };

  const handleStart = () => {
    void unlockPracticeAudio();
    const settings = buildSettings();
    PracticeSettingsService.saveSettings(settings);
    onStart(settings);
  };

  const handleStartPlayer = () => {
    void unlockListeningAudio();
    void unlockPracticeAudio({ forceEnabled: true });
    const settings = buildSettings();
    PracticeSettingsService.saveSettings(settings);
    onStartPlayer?.(settings);
  };

  if (!isOpen) return null;

  return (
    <div className="practice-settings-overlay" onClick={onClose}>
      <div className="practice-settings-modal" onClick={(event) => event.stopPropagation()}>
        <div className="practice-stage-list">
          {description && <p>{description}</p>}
          {errorMessage && <p role="alert">{errorMessage}</p>}
          <button type="button" className="practice-stage-card practice-stage-card-test" onClick={handleStart}>
            <img className="practice-stage-image" src={testAndRepeatImage} alt="" aria-hidden="true" />
            <span className="practice-stage-copy">
              <strong>{t('practicePlayer.settings.testRepeatName')}</strong>
              <span>{t('practicePlayer.settings.testRepeatDescription')}</span>
            </span>
          </button>
          {onStartPlayer && (
            <button type="button" className="practice-stage-card practice-stage-card-listening" onClick={handleStartPlayer}>
              <img className="practice-stage-image" src={listeningPracticeImage} alt="" aria-hidden="true" />
              <span className="practice-stage-copy">
                <strong>{t('practicePlayer.settings.listeningName')}</strong>
                <span>{t('practicePlayer.settings.listeningDescription')}</span>
              </span>
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default PracticeSettings;
